module.exports = __webpack_public_path__ + "static/media/icon-header-checkin.0bbba958.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-checkin.svg
// module id = 1506
// module chunks = 193